import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from "react";
import { Audio as AudioSpinner } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import { push } from "connected-react-router/esm/index.js";
import { useTheme } from "@emotion/react";
// import { IStore } from "@store/types";
import { useSelector, useDispatch } from "react-redux";
import ProjectEditor from "@comp/project-editor/project-editor";
import { cleanupNonCloudFiles } from "@comp/file-tree/actions";
import Header from "@comp/header/header";
import { activateProject, downloadProjectOnce } from "./actions";
import * as SS from "./styles";
import { isEmpty, path, pathOr } from "ramda";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ForceBackgroundColor = function ForceBackgroundColor(_ref) {
    var theme = _ref.theme;
    return ___EmotionJSX("style", null, "body {background-color: ".concat(theme.background, "}"));
};
var ProjectContext = function ProjectContext(properties) {
    var _routeParams$id;
    var dispatch = useDispatch();
    var theme = useTheme();
    var routeParams = useParams();
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), projectFetchStarted = _useState2[0], setProjectFetchStarted = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), projectIsReady = _useState4[0], setProjectIsReady = _useState4[1];
    var _useState5 = useState(true), _useState6 = _slicedToArray(_useState5, 2), needsLoading = _useState6[0], setNeedsLoading = _useState6[1];
    var projectUid = (_routeParams$id = routeParams.id) !== null && _routeParams$id !== void 0 ? _routeParams$id : "";
    var invalidUrl = !projectUid || isEmpty(projectUid);
    // this is true when /editor path is missing projectUid
    invalidUrl && dispatch(push({
        pathname: "/404"
    }, {
        message: "Project not found"
    }));
    var activeProjectUid = useSelector(function (store) {
        return !invalidUrl && path(["ProjectsReducer", "activeProjectUid"], store);
    });
    var project = useSelector(function (store) {
        return activeProjectUid && !invalidUrl && path(["ProjectsReducer", "projects", activeProjectUid], store);
    });
    var tabIndex = useSelector(pathOr(-1, ["ProjectEditorReducer", "tabDock", "tabIndex"]));
    useEffect(function () {
        if (!projectFetchStarted) {
            var initProject = /*#__PURE__*/ function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1)
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return downloadProjectOnce(projectUid)(dispatch);
                                case 3:
                                    _context.next = 8;
                                    break;
                                case 5:
                                    _context.prev = 5;
                                    _context.t0 = _context["catch"](0);
                                    if (_typeof(_context.t0) === "object" && typeof _context.t0.code === "string") {
                                        _context.t0.code === "permission-denied" && dispatch(push({
                                            pathname: "/404"
                                        }, {
                                            message: "Project not found"
                                        }));
                                    }
                                case 8:
                                    dispatch(cleanupNonCloudFiles({
                                        projectUid: projectUid
                                    }));
                                    _context.next = 11;
                                    return activateProject(projectUid)(dispatch);
                                case 11:
                                    setProjectIsReady(true);
                                case 12:
                                case "end":
                                    return _context.stop();
                            }
                    }, _callee, null, [[0, 5]]);
                }));
                return function initProject() {
                    return _ref2.apply(this, arguments);
                };
            }();
            setProjectFetchStarted(true);
            initProject();
        }
        if (needsLoading && projectFetchStarted && projectIsReady) {
            setNeedsLoading(false);
        }
    }, [dispatch, project, projectUid, activeProjectUid, needsLoading, projectIsReady, projectFetchStarted, tabIndex]);
    return !needsLoading && !invalidUrl && project ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ForceBackgroundColor, {
        theme: theme
    }), ___EmotionJSX(ProjectEditor, _extends({}, properties, {
        activeProject: project
    })), ___EmotionJSX(Header, null)) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ForceBackgroundColor, {
        theme: theme
    }), ___EmotionJSX(Header, null), ___EmotionJSX("main", {
        css: SS.loadMain
    }, ___EmotionJSX(AudioSpinner, {
        color: theme.highlightBackground,
        height: 80,
        width: 80
    })));
};
export default ProjectContext;
